// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2MGRK","selects":"Documents_selects__AT7Dj"};